export default __webpack_public_path__ + "static/media/error.51731f25.svg";